// AUTO-GENERATED FILE. DO NOT EDIT.
// Generated by `apps/agent-stream/src/prebuild.ts` during the build step.
// To regenerate, run the prebuild script. Do not modify manually — including AI agents.
// File-level noExplicitAny disabled in biome.json - Auto-generated file
import type { ActionCreatorWithPayload, PayloadAction } from '@reduxjs/toolkit';
import { createAction } from '@reduxjs/toolkit';

import { updateDisclaimerMessage } from "@polyai/stream/store/reducers/agent-settings/actions";
import { updateGreeting } from "@polyai/stream/store/reducers/agent-settings/actions";
import { updateLanguageBehavior } from "@polyai/stream/store/reducers/agent-settings/actions";
import { updatePersonality } from "@polyai/stream/store/reducers/agent-settings/actions";
import { updateRole } from "@polyai/stream/store/reducers/agent-settings/actions";
import { updateRules } from "@polyai/stream/store/reducers/agent-settings/actions";
import { createApiIntegration } from "@polyai/stream/store/reducers/api-integrations/actions";
import { createApiIntegrationOperation } from "@polyai/stream/store/reducers/api-integrations/actions";
import { deleteApiIntegration } from "@polyai/stream/store/reducers/api-integrations/actions";
import { deleteApiIntegrationOperation } from "@polyai/stream/store/reducers/api-integrations/actions";
import { updateApiIntegration } from "@polyai/stream/store/reducers/api-integrations/actions";
import { updateApiIntegrationConfig } from "@polyai/stream/store/reducers/api-integrations/actions";
import { updateApiIntegrationOperation } from "@polyai/stream/store/reducers/api-integrations/actions";
import { updateAsrSettings } from "@polyai/stream/store/reducers/asr-settings/actions";
import { resetVoiceChannelAsrConfig } from "@polyai/stream/store/reducers/channels/actions";
import { resetVoiceChannelAudioEnhancement } from "@polyai/stream/store/reducers/channels/actions";
import { resetVoiceChannelBargeInConfig } from "@polyai/stream/store/reducers/channels/actions";
import { resetVoiceChannelSilenceFillerUtterances } from "@polyai/stream/store/reducers/channels/actions";
import { resetVoiceChannelTemperature } from "@polyai/stream/store/reducers/channels/actions";
import { resetVoiceChannelVadConfig } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelAsrConfig } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelASRSettings } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelAudioEnhancement } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelBargeInConfig } from "@polyai/stream/store/reducers/channels/actions";
import { updateChannelGreeting } from "@polyai/stream/store/reducers/channels/actions";
import { updateChannelStylePrompt } from "@polyai/stream/store/reducers/channels/actions";
import { updateChannelSafetyFilters } from "@polyai/stream/store/reducers/channels/actions";
import { updateChannelLLMSettings } from "@polyai/stream/store/reducers/channels/actions";
import { updateChannelStatus } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelDisclaimer } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelSilenceFillerUtterances } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelTemperature } from "@polyai/stream/store/reducers/channels/actions";
import { updateVoiceChannelVadConfig } from "@polyai/stream/store/reducers/channels/actions";
import { updateContentFilterSettings } from "@polyai/stream/store/reducers/content-filter-settings/actions";
import { updateCsatConfig } from "@polyai/stream/store/reducers/csat";
import { createEntity } from "@polyai/stream/store/reducers/entities/actions";
import { deleteEntity } from "@polyai/stream/store/reducers/entities/actions";
import { updateEntity } from "@polyai/stream/store/reducers/entities/actions";
import { updateExperimentalConfig } from "@polyai/stream/store/reducers/experimental-config/actions";
import { createFlow } from "@polyai/stream/store/reducers/flows/actions";
import { createFlowStep } from "@polyai/stream/store/reducers/flows/actions";
import { createNoCodeCondition } from "@polyai/stream/store/reducers/flows/actions";
import { createNoCodeStep } from "@polyai/stream/store/reducers/flows/actions";
import { createStep } from "@polyai/stream/store/reducers/flows/actions";
import { createStepCondition } from "@polyai/stream/store/reducers/flows/actions";
import { createFlowTransitionFunction } from "@polyai/stream/store/reducers/flows/actions";
import { deleteFlow } from "@polyai/stream/store/reducers/flows/actions";
import { deleteFlowStep } from "@polyai/stream/store/reducers/flows/actions";
import { deleteNoCodeCondition } from "@polyai/stream/store/reducers/flows/actions";
import { deleteNoCodeStep } from "@polyai/stream/store/reducers/flows/actions";
import { deleteStep } from "@polyai/stream/store/reducers/flows/actions";
import { deleteStepCondition } from "@polyai/stream/store/reducers/flows/actions";
import { deleteFlowTransitionFunction } from "@polyai/stream/store/reducers/flows/actions";
import { importFlow } from "@polyai/stream/store/reducers/flows/actions";
import { moveFlowComponent } from "@polyai/stream/store/reducers/flows/actions";
import { moveFlowComponents } from "@polyai/stream/store/reducers/flows/actions";
import { updateNoCodeConditionExitFlowPosition } from "@polyai/stream/store/reducers/flows";
import { updateFlow } from "@polyai/stream/store/reducers/flows";
import { updateFlowStep } from "@polyai/stream/store/reducers/flows/actions";
import { updateNoCodeCondition } from "@polyai/stream/store/reducers/flows/actions";
import { updateNoCodeConditionPosition } from "@polyai/stream/store/reducers/flows/actions";
import { updateNoCodeStep } from "@polyai/stream/store/reducers/flows/actions";
import { updateNoCodeStepPosition } from "@polyai/stream/store/reducers/flows/actions";
import { updateStep } from "@polyai/stream/store/reducers/flows/actions";
import { updateFlowStepASRConfig } from "@polyai/stream/store/reducers/flows/actions";
import { updateStepCondition } from "@polyai/stream/store/reducers/flows/actions";
import { updateStepConditionPosition } from "@polyai/stream/store/reducers/flows/actions";
import { editFlowStepDTMFConfig } from "@polyai/stream/store/reducers/flows";
import { updateStepPosition } from "@polyai/stream/store/reducers/flows/actions";
import { updateStepPositions } from "@polyai/stream/store/reducers/flows/actions";
import { updateFlowTransitionFunction } from "@polyai/stream/store/reducers/flows/actions";
import { updateFlowTransitionFunctionLatencyControl } from "@polyai/stream/store/reducers/flows/actions";
import { createFunction } from "@polyai/stream/store/reducers/functions";
import { deleteFunction } from "@polyai/stream/store/reducers/functions";
import { updateFunction } from "@polyai/stream/store/reducers/functions";
import { updateLatencyControl } from "@polyai/stream/store/reducers/functions";
import { updateGuardrails } from "@polyai/stream/store/reducers/guardrails/actions";
import { createHandoff } from "@polyai/stream/store/reducers/handoff/actions";
import { deleteHandoff } from "@polyai/stream/store/reducers/handoff/actions";
import { resetHandoffConfigs } from "@polyai/stream/store/reducers/handoff/actions";
import { setDefaultHandoff } from "@polyai/stream/store/reducers/handoff/actions";
import { updateHandoff } from "@polyai/stream/store/reducers/handoff/actions";
import { connectIntegration } from "@polyai/stream/store/reducers/integrations";
import { disableIntegration } from "@polyai/stream/store/reducers/integrations";
import { disconnectIntegration } from "@polyai/stream/store/reducers/integrations";
import { enableIntegration } from "@polyai/stream/store/reducers/integrations";
import { updateIntegrationFunctions } from "@polyai/stream/store/reducers/integrations";
import { createKeyphraseBoosting } from "@polyai/stream/store/reducers/keyphrase-boosting/actions";
import { deleteKeyphraseBoosting } from "@polyai/stream/store/reducers/keyphrase-boosting/actions";
import { updateKeyphraseBoosting } from "@polyai/stream/store/reducers/keyphrase-boosting/actions";
import { createTopic } from "@polyai/stream/store/reducers/knowledge-base";
import { deleteTopic } from "@polyai/stream/store/reducers/knowledge-base";
import { importTopics } from "@polyai/stream/store/reducers/knowledge-base/actions";
import { setEmbeddingModel } from "@polyai/stream/store/reducers/knowledge-base/actions";
import { toggleTopicStatus } from "@polyai/stream/store/reducers/knowledge-base";
import { updateTopic } from "@polyai/stream/store/reducers/knowledge-base";
import { addLanguage } from "@polyai/stream/store/reducers/languages/actions";
import { deleteLanguage } from "@polyai/stream/store/reducers/languages/actions";
import { updateDefaultLanguage } from "@polyai/stream/store/reducers/languages/actions";
import { updateLLMSettings } from "@polyai/stream/store/reducers/llm-settings/actions";
import { deleteMcpProfile } from "@polyai/stream/store/reducers/mcp-config/actions";
import { deleteMcpServer } from "@polyai/stream/store/reducers/mcp-config/actions";
import { updateMcpConfig } from "@polyai/stream/store/reducers/mcp-config/actions";
import { upsertMcpProfile } from "@polyai/stream/store/reducers/mcp-config/actions";
import { upsertMcpServer } from "@polyai/stream/store/reducers/mcp-config/actions";
import { createPronunciation } from "@polyai/stream/store/reducers/pronunciations/actions";
import { deletePronunciation } from "@polyai/stream/store/reducers/pronunciations/actions";
import { reorderPronunciations } from "@polyai/stream/store/reducers/pronunciations/actions";
import { updatePronunciation } from "@polyai/stream/store/reducers/pronunciations/actions";
import { createTemplate } from "@polyai/stream/store/reducers/sms";
import { deleteTemplate } from "@polyai/stream/store/reducers/sms";
import { duplicateTemplate } from "@polyai/stream/store/reducers/sms";
import { updateTemplate } from "@polyai/stream/store/reducers/sms";
import { createStopKeywords } from "@polyai/stream/store/reducers/stop-keywords";
import { deleteStopKeywords } from "@polyai/stream/store/reducers/stop-keywords";
import { updateStopKeywords } from "@polyai/stream/store/reducers/stop-keywords";
import { createTestCase } from "@polyai/stream/store/reducers/testing";
import { deleteTestCase } from "@polyai/stream/store/reducers/testing";
import { setTestCaseAssertions } from "@polyai/stream/store/reducers/testing";
import { setTestCaseFunctionCalls } from "@polyai/stream/store/reducers/testing";
import { setTestCaseTags } from "@polyai/stream/store/reducers/testing";
import { updateTestCase } from "@polyai/stream/store/reducers/testing";
import { createTranscriptCorrectionsAction } from "@polyai/stream/store/reducers/transcript-corrections/actions";
import { deleteTranscriptCorrectionsAction } from "@polyai/stream/store/reducers/transcript-corrections/actions";
import { updateTranscriptCorrectionsAction } from "@polyai/stream/store/reducers/transcript-corrections/actions";
import { createTranslation } from "@polyai/stream/store/reducers/translations/actions";
import { deleteTranslation } from "@polyai/stream/store/reducers/translations/actions";
import { updateTranslation } from "@polyai/stream/store/reducers/translations/actions";
import { createVariable } from "@polyai/stream/store/reducers/variables";
import { deleteVariable } from "@polyai/stream/store/reducers/variables";
import { updateVariable } from "@polyai/stream/store/reducers/variables";
import { createAttribute } from "@polyai/stream/store/reducers/variant";
import { createVariant } from "@polyai/stream/store/reducers/variant";
import { deleteAttribute } from "@polyai/stream/store/reducers/variant";
import { deleteVariant } from "@polyai/stream/store/reducers/variant";
import { variantImportVariants } from "@polyai/stream/store/reducers/variant";
import { setDefaultVariant } from "@polyai/stream/store/reducers/variant/actions";
import { updateAttribute } from "@polyai/stream/store/reducers/variant";
import { updateVariant } from "@polyai/stream/store/reducers/variant";
import { addAgentVoice } from "@polyai/stream/store/reducers/voices";
import { addFavoriteVoice } from "@polyai/stream/store/reducers/voices";
import { createAgentVoiceSettings } from "@polyai/stream/store/reducers/voices";
import { createDisclaimerVoiceSettings } from "@polyai/stream/store/reducers/voices";
import { deleteAgentVoice } from "@polyai/stream/store/reducers/voices";
import { removeFavoriteVoice } from "@polyai/stream/store/reducers/voices";
import { updateAgentVoice } from "@polyai/stream/store/reducers/voices";
import { updateAgentVoiceSettings } from "@polyai/stream/store/reducers/voices";
import { updateDisclaimerVoice } from "@polyai/stream/store/reducers/voices";
import { updateDisclaimerVoiceSettings } from "@polyai/stream/store/reducers/voices";
import { createEndFunction } from "@polyai/stream/store/reducers/specialFunctions/actions";
import { createStartFunction } from "@polyai/stream/store/reducers/specialFunctions/actions";
import { deleteEndFunction } from "@polyai/stream/store/reducers/specialFunctions/actions";
import { deleteStartFunction } from "@polyai/stream/store/reducers/specialFunctions/actions";
import { updateEndFunction } from "@polyai/stream/store/reducers/specialFunctions/actions";
import { updateStartFunction } from "@polyai/stream/store/reducers/specialFunctions/actions";

import custom from '@polyai/stream/commands/mapper/customMappings'
import type { EventType } from "@polyai/stream/commands/types";

export const EVENT_ACTION_MAPPINGS: Partial<Record<EventType, ActionCreatorWithPayload<any>>> = {
'updateDisclaimerMessage': updateDisclaimerMessage,
'updateGreeting': updateGreeting,
'updateLanguageBehavior': updateLanguageBehavior,
'updatePersonality': updatePersonality,
'updateRole': updateRole,
'updateRules': updateRules,
'createApiIntegration': createApiIntegration,
'createApiIntegrationOperation': createApiIntegrationOperation,
'deleteApiIntegration': deleteApiIntegration,
'deleteApiIntegrationOperation': deleteApiIntegrationOperation,
'updateApiIntegration': updateApiIntegration,
'updateApiIntegrationConfig': updateApiIntegrationConfig,
'updateApiIntegrationOperation': updateApiIntegrationOperation,
'updateAsrSettings': updateAsrSettings,
'voiceChannelResetAsrConfig': resetVoiceChannelAsrConfig,
'voiceChannelResetAudioEnhancement': resetVoiceChannelAudioEnhancement,
'voiceChannelResetBargeInConfig': resetVoiceChannelBargeInConfig,
'voiceChannelResetSilenceFillerUtterances': resetVoiceChannelSilenceFillerUtterances,
'voiceChannelResetTemperature': resetVoiceChannelTemperature,
'voiceChannelResetVadConfig': resetVoiceChannelVadConfig,
'voiceChannelUpdateAsrConfig': updateVoiceChannelAsrConfig,
'voiceChannelUpdateAsrSettings': updateVoiceChannelASRSettings,
'voiceChannelUpdateAudioEnhancement': updateVoiceChannelAudioEnhancement,
'voiceChannelUpdateBargeInConfig': updateVoiceChannelBargeInConfig,
'channelUpdateGreeting': updateChannelGreeting,
'channelUpdateStylePrompt': updateChannelStylePrompt,
'channelUpdateSafetyFilters': updateChannelSafetyFilters,
'channelUpdateLlmSettings': updateChannelLLMSettings,
'channelUpdateStatus': updateChannelStatus,
'voiceChannelUpdateDisclaimer': updateVoiceChannelDisclaimer,
'voiceChannelUpdateSilenceFillerUtterances': updateVoiceChannelSilenceFillerUtterances,
'voiceChannelUpdateTemperature': updateVoiceChannelTemperature,
'voiceChannelUpdateVadConfig': updateVoiceChannelVadConfig,
'updateContentFilterSettings': updateContentFilterSettings,
'csatUpdateConfig': updateCsatConfig,
'entityCreate': createEntity,
'entityDelete': deleteEntity,
'entityUpdate': updateEntity,
'experimentalConfigUpdateConfig': updateExperimentalConfig,
'createFlow': createFlow,
'createFlowStep': createFlowStep,
'createNoCodeCondition': createNoCodeCondition,
'createNoCodeStep': createNoCodeStep,
'createStep': createStep,
'createStepCondition': createStepCondition,
'createFlowTransitionFunction': createFlowTransitionFunction,
'deleteFlow': deleteFlow,
'deleteFlowStep': deleteFlowStep,
'deleteNoCodeCondition': deleteNoCodeCondition,
'deleteNoCodeStep': deleteNoCodeStep,
'deleteStep': deleteStep,
'deleteStepCondition': deleteStepCondition,
'deleteFlowTransitionFunction': deleteFlowTransitionFunction,
'importFlow': importFlow,
'moveFlowComponent': moveFlowComponent,
'moveFlowComponents': moveFlowComponents,
'updateNoCodeConditionExitFlowPosition': updateNoCodeConditionExitFlowPosition,
'updateFlow': updateFlow,
'updateFlowStep': updateFlowStep,
'updateNoCodeCondition': updateNoCodeCondition,
'updateNoCodeConditionPosition': updateNoCodeConditionPosition,
'updateNoCodeStep': updateNoCodeStep,
'updateNoCodeStepPosition': updateNoCodeStepPosition,
'updateStep': updateStep,
'updateFlowStepAsrConfig': updateFlowStepASRConfig,
'updateStepCondition': updateStepCondition,
'updateStepConditionPosition': updateStepConditionPosition,
'updateFlowStepDtmfConfig': editFlowStepDTMFConfig,
'updateFlowStepPosition': updateStepPosition,
'updateFlowStepPositions': updateStepPositions,
'updateFlowTransitionFunction': updateFlowTransitionFunction,
'updateFlowTransitionFunctionLatencyControl': updateFlowTransitionFunctionLatencyControl,
'createFunction': createFunction,
'deleteFunction': deleteFunction,
'updateFunction': updateFunction,
'updateLatencyControl': updateLatencyControl,
'updateGuardrails': updateGuardrails,
'handoffCreate': createHandoff,
'handoffDelete': deleteHandoff,
'handoffResetHandoffConfigs': resetHandoffConfigs,
'handoffSetDefault': setDefaultHandoff,
'handoffUpdate': updateHandoff,
'connectIntegration': connectIntegration,
'disableIntegration': disableIntegration,
'disconnectIntegration': disconnectIntegration,
'enableIntegration': enableIntegration,
'updateIntegrationFunctions': updateIntegrationFunctions,
'createKeyphraseBoosting': createKeyphraseBoosting,
'deleteKeyphraseBoosting': deleteKeyphraseBoosting,
'updateKeyphraseBoosting': updateKeyphraseBoosting,
'createTopic': createTopic,
'deleteTopic': deleteTopic,
'importTopics': importTopics,
'setEmbeddingModel': setEmbeddingModel,
'toggleTopicStatus': toggleTopicStatus,
'updateTopic': updateTopic,
'languagesAddLanguage': addLanguage,
'languagesDeleteLanguage': deleteLanguage,
'languagesUpdateDefaultLanguage': updateDefaultLanguage,
'updateLlmSettings': updateLLMSettings,
'deleteMcpProfile': deleteMcpProfile,
'deleteMcpServer': deleteMcpServer,
'updateMcpConfig': updateMcpConfig,
'upsertMcpProfile': upsertMcpProfile,
'upsertMcpServer': upsertMcpServer,
'pronunciationsCreatePronunciation': createPronunciation,
'pronunciationsDeletePronunciation': deletePronunciation,
'pronunciationsReorderPronunciations': reorderPronunciations,
'pronunciationsUpdatePronunciation': updatePronunciation,
'smsCreateTemplate': createTemplate,
'smsDeleteTemplate': deleteTemplate,
'smsDuplicateTemplate': duplicateTemplate,
'smsUpdateTemplate': updateTemplate,
'stopKeywordsCreate': createStopKeywords,
'stopKeywordsDelete': deleteStopKeywords,
'stopKeywordsUpdate': updateStopKeywords,
'createTestCase': createTestCase,
'deleteTestCase': deleteTestCase,
'setTestCaseAssertions': setTestCaseAssertions,
'setTestCaseFunctionCalls': setTestCaseFunctionCalls,
'setTestCaseTags': setTestCaseTags,
'updateTestCase': updateTestCase,
'createTranscriptCorrections': createTranscriptCorrectionsAction,
'deleteTranscriptCorrections': deleteTranscriptCorrectionsAction,
'updateTranscriptCorrections': updateTranscriptCorrectionsAction,
'createTranslation': createTranslation,
'deleteTranslation': deleteTranslation,
'updateTranslation': updateTranslation,
'variableCreate': createVariable,
'variableDelete': deleteVariable,
'variableUpdate': updateVariable,
'variantCreateAttribute': createAttribute,
'variantCreateVariant': createVariant,
'variantDeleteAttribute': deleteAttribute,
'variantDeleteVariant': deleteVariant,
'variantImportVariants': variantImportVariants,
'variantSetDefaultVariant': setDefaultVariant,
'variantUpdateAttribute': updateAttribute,
'variantUpdateVariant': updateVariant,
'voiceAddAgentVoice': addAgentVoice,
'voiceAddFavoriteVoice': addFavoriteVoice,
'voiceCreateAgentVoiceSettings': createAgentVoiceSettings,
'voiceCreateDisclaimerVoiceSettings': createDisclaimerVoiceSettings,
'voiceDeleteAgentVoice': deleteAgentVoice,
'voiceRemoveFavoriteVoice': removeFavoriteVoice,
'voiceUpdateAgentVoice': updateAgentVoice,
'voiceUpdateAgentVoiceSettings': updateAgentVoiceSettings,
'voiceUpdateDisclaimerVoice': updateDisclaimerVoice,
'voiceUpdateDisclaimerVoiceSettings': updateDisclaimerVoiceSettings,
'createEndFunction': createEndFunction,
'createStartFunction': createStartFunction,
'deleteEndFunction': deleteEndFunction,
'deleteStartFunction': deleteStartFunction,
'updateEndFunction': updateEndFunction,
'updateStartFunction': updateStartFunction,
  ...custom
};

export const getActionForEvent = (event: EventType) => {
  if (event in EVENT_ACTION_MAPPINGS) {
    return EVENT_ACTION_MAPPINGS[event]!;
  }
  return createAction(event);
};

export const getEventTypeForAction = (action: PayloadAction<any>) => {
  const meta = Object.entries(EVENT_ACTION_MAPPINGS).find(
    ([, creator]) => {
      return creator.match(action);
    },
  );

  if (!meta) {
    return null;
  }

  const [eventType] = meta;

  return eventType;
};
